var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"m-1",on:{"click":_vm.goBack}},[_c('b-icon',{attrs:{"icon":"arrow-left"}}),_vm._v(" Go Back")],1)}
var staticRenderFns = []

export { render, staticRenderFns }